import React, { useState, useEffect, useCallback } from "react";
import {
  BusinessAdministrationAddressView,
  BusinessAdministrationDisableView,
  BusinessAdministrationDetailView,
} from "../../views";
// import "./business-administration-panel.css";
import { businessIconDefault } from "../../../assets/logos/icons";
import { ClientCompanyService } from "../../../services";
import moment from "moment";
import "moment/locale/es";

/**
 * @param {*} {
 *   selectedUser,
 *   hideShowDetails,
 *   nameComponentUser,
 *   optionsTypeBusiness,
 *   optionsBusinessTurnover,
 *   setHeaderTitleinDetail,
 *   token,
 *   validators,
 *   forceRefresh,
 *   toggleCompleted,
 *   onChangeImgProfile,
 *   setShowDetails,
 *   setNameComponentUser,
 *   showLoadingRequesting,
 *   showCompletedRequesting,
 *   showErrorRequesting,
 *   showWarningRequesting,
 *   userInformation,
 *   toggleCompletedRequesting,
 *   toggleLoadingRequesting,
 *   toggleErrorRequesting,
 *   toggleCompletedModel,
 *   toggleWarningRequesting,
 *   resetImageProfile,
 *   message,
 *   setDataUser,
 *   clientCompany,
 *   imageProfile,
 * }
 * @status no delete
 * @description Layout for the business administration configuration page 
 * @return {*} 
 */
const BusinessAdministrationConfigurationsView = ({
  selectedUser,
  hideShowDetails,
  nameComponentUser,
  optionsTypeBusiness,
  optionsBusinessTurnover,
  setHeaderTitleinDetail,
  token,
  validators,
  forceRefresh,
  toggleCompleted,
  onChangeImgProfile,
  setShowDetails,
  showLoadingRequesting,
  showCompletedRequesting,
  showErrorRequesting,
  showWarningRequesting,
  userInformation,
  toggleCompletedRequesting,
  toggleLoadingRequesting,
  toggleErrorRequesting,
  toggleCompletedModel,
  toggleWarningRequesting,
  resetImageProfile,
  message,
  imageProfile,
}) => {
  const [stateNameComponentUser, setStateNameComponentUser] = useState("");
  const [showGettingData, setShowGettingData] = useState(false);
  const [showDetailComponent, setShowComponentDetail] = useState(false);
  const [imgProfileSubtitle, setImgProfileSubtitle] = useState("");
  const [valueImgProfile, setValueImgProfile] = useState();

  const [dataImgProfile, setDataImgProfile] = useState();


  const toggleShowDetailComponent = () => {
    setShowComponentDetail(false);
    setStateNameComponentUser("Ver detalle/Editar");
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  /**
   * @description  Funtion to upload file
   * @status no delete
   * @param {*} ref
   */
  const uploadFileCustom = (ref) => {
    ref.current.click();
  };


  /**
   * @description handler to change the user profile
   * @status no delete
   * @param {*} token
   * @param {*} dataImgProfile
   * @return {*} 
   */
  const handleChangeImgProfile = async (token, dataImgProfile) => {
    toggleLoadingRequesting(true);
    try {
      let clientCompanyService = new ClientCompanyService(
        process.env.REACT_APP_ETICKET_API
      );
      let res = await clientCompanyService.updateClientCompanyLogo(
        token,
        dataImgProfile
      );
      if (res && res.statusCode === 200) {
        let clientsCompanyInfo = await clientCompanyService.getClientCompany(
          userInformation.clientId,
          token
        );
        toggleLoadingRequesting(false);
        moment.locale("es");
        clientsCompanyInfo.data.map((client) => {
          client.clientName = client.company.businessName;
          let dateModification = client.updatedDate.split("T")[0];
          client.lastModificationDate = moment(dateModification)
            .format("DD-MMM-YYYY")
            .replace(/\./g, "");
          client.status = client.company.status;
          client.imgProfile =
            client.company.logo === null
              ? businessIconDefault
              : client.company.logo;
          client.companyName = client.company.companyName;
          client.turnOfTheCompany = client.company.turnOfTheCompany;
          client.typeOfCompany = client.company.typeOfCompany;

          return clientsCompanyInfo.data;
        });
        toggleCompletedRequesting(true, " ", clientsCompanyInfo.data);
        setTimeout(() => {
          hideShowDetails();
        }, 4000);
      } else if (res && res.statusCode === -1) {
        toggleLoadingRequesting(false);
        toggleErrorRequesting(true, " ");
        setTimeout(() => {
          hideShowDetails();
        }, 4000);
      }
    } catch (error) {
      toggleLoadingRequesting(false);
      toggleErrorRequesting(true, " ");

      setTimeout(() => {
        hideShowDetails();
      }, 4000);
      return false;
    }
  };


  /**
   * @description save status for company
   * @status no delete
   * @param {*} token
   * @param {*} clientCompanyStatus
   */
  const saveStatusForCompany = async (token, clientCompanyStatus) => {
    toggleLoadingRequesting(true);

    try {
      let clientCompanyService = new ClientCompanyService(
        process.env.REACT_APP_ETICKET_API
      );
      let res = await clientCompanyService.updateClientCompanyStatus(
        token,
        clientCompanyStatus
      );
      if (typeof imageProfile !== "string") {
        let body = new FormData();
        body.append("companyId", res.data.id);
        body.append("logo", imageProfile);
        await clientCompanyService.updateClientCompanyLogo(token, body);
      }
      if (res && res.statusCode === 200) {
        let clientsCompanyInfo = await clientCompanyService.getClientCompany(
          userInformation.clientId,
          token
        );
        moment.locale("es");
        clientsCompanyInfo.data.map((client) => {
          client.clientName = client.company.businessName;
          let dateModification = client.updatedDate.split("T")[0];
          client.lastModificationDate = moment(dateModification)
            .format("DD-MMM-YYYY")
            .replace(/\./g, "");
          client.status = client.company.status;
          client.imgProfile =
            client.company.logo === null
              ? businessIconDefault
              : client.company.logo;
          client.companyName = client.company.companyName;
          client.turnOfTheCompany = client.company.turnOfTheCompany;
          client.typeOfCompany = client.company.typeOfCompany;

          return clientsCompanyInfo.data;
        });
        toggleLoadingRequesting(false);
        toggleCompletedRequesting(true, " ", clientsCompanyInfo.data);
        setTimeout(() => {
          hideShowDetails();
        }, 4000);
      } else if (res && res.statusCode === -1) {
        toggleLoadingRequesting(false);
        toggleErrorRequesting(true, " ");
        setTimeout(() => {
          hideShowDetails();
        }, 4000);
      }
    } catch (error) {
      toggleLoadingRequesting(false);
      toggleErrorRequesting(true, " ");
      setTimeout(() => {
        hideShowDetails();
      }, 4000);
    }
  };

  /**
   * @description Create client company
   * @status no delete
   * @param {*} token
   * @param {*} clientCompanyInformation
   */
  const createCompany = async (token, clientCompanyInformation) => {
    toggleLoadingRequesting(true);
    let clientCompanyService = new ClientCompanyService(
      process.env.REACT_APP_ETICKET_API
    );
    try {
      if (clientCompanyInformation && imageProfile) {
        let res = await clientCompanyService.createNewClientCompany(
          token,
          clientCompanyInformation
        );
        if (res && res.statusCode === 200) {
          if (typeof imageProfile !== "string") {
            let body = new FormData();
            body.append("companyId", res.data.company.id);
            body.append("logo", imageProfile);
            let updateImg = await clientCompanyService.updateClientCompanyLogo(
              token,
              body
            );
            if (updateImg.statusCode !== 200) {
              toggleWarningRequesting(true, "Agrega una  imagen.");
            }
          }
          let clientsCompanyInfo = await clientCompanyService.getClientCompany(
            userInformation.clientId,
            token
          );

          moment.locale("es");
          clientsCompanyInfo.data.map((client) => {
            client.clientName = client.company.businessName;
            let dateModification = client.updatedDate.split("T")[0];
            client.lastModificationDate = moment(dateModification)
              .format("DD-MMM-YYYY")
              .replace(/\./g, "");
            client.status = client.company.status;
            client.imgProfile =
              client.company.logo === null
                ? businessIconDefault
                : client.company.logo;
            client.companyName = client.company.companyName;
            client.turnOfTheCompany = client.company.turnOfTheCompany;
            client.typeOfCompany = client.company.typeOfCompany;

            return clientsCompanyInfo.data;
          });
          toggleLoadingRequesting(false);
          toggleCompletedRequesting(true, " ", clientsCompanyInfo.data);
          setTimeout(() => {
            hideShowDetails();
          }, 4000);
        } else if (res) {
          toggleLoadingRequesting(false);
          toggleErrorRequesting(true, res.message);
        }
      }
    } catch (error) {
      toggleLoadingRequesting(false);
      toggleErrorRequesting(true, " ");
      setTimeout(() => {
        hideShowDetails();
      }, 4000);
    }
  };

  /**
   * @description Update client company
   * @status no delete
   * @param {*} token
   * @param {*} clientCompanyInformation
   */
  const updateCompany = async (token, clientCompanyInformation) => {
    toggleLoadingRequesting(true);

    try {
      let clientCompanyService = new ClientCompanyService(
        process.env.REACT_APP_ETICKET_API
      );
      let res = await clientCompanyService.updateClientCompany(
        token,
        clientCompanyInformation
      );
      if (typeof imageProfile !== "string") {
        let body = new FormData();
        body.append("companyId", res.data.id);
        body.append("logo", imageProfile);
        await clientCompanyService.updateClientCompanyLogo(token, body);
      }
      if (res && res.statusCode === 200) {
        let clientsCompanyInfo = await clientCompanyService.getClientCompany(
          userInformation.clientId,
          token
        );
        moment.locale("es");
        clientsCompanyInfo.data.map((client) => {
          client.clientName = client.company.businessName;
          let dateModification = client.updatedDate.split("T")[0];
          client.lastModificationDate = moment(dateModification)
            .format("DD-MMM-YYYY")
            .replace(/\./g, "");
          client.status = client.company.status;
          client.imgProfile =
            client.company.logo === null
              ? businessIconDefault
              : client.company.logo;
          client.companyName = client.company.companyName;
          client.description = client.company.description;
          client.turnOfTheCompany = client.company.turnOfTheCompany;
          client.typeOfCompany = client.company.typeOfCompany;

          return clientsCompanyInfo.data;
        });
        toggleLoadingRequesting(false);
        toggleCompletedRequesting(true, " ", clientsCompanyInfo.data);
        setTimeout(() => {
          hideShowDetails();
        }, 4000);
      } else if (res && res.statusCode === -1) {
        toggleLoadingRequesting(false);
        toggleErrorRequesting(true, " ");
      }
    } catch (error) {
      toggleLoadingRequesting(false);
      toggleErrorRequesting(true, " ");
      setTimeout(() => {
        hideShowDetails();
      }, 4000);
    }
  };

  /**
   * @description Create address client company
   * @status no delete
   * @param {*} token
   * @param {*} clientCompanyInformation
   * @return {*} 
   */
  const updateAddress = async (token, clientCompanyInformation) => {
    toggleLoadingRequesting(true);
    try {
      let clientCompanyService = new ClientCompanyService(
        process.env.REACT_APP_ETICKET_API
      );
      let res = await clientCompanyService.updateClientCompanyAddress(
        token,
        clientCompanyInformation
      );
      if (typeof imageProfile !== "string") {
        let body = new FormData();
        body.append("companyId", res.data.id);
        body.append("logo", imageProfile);
        await clientCompanyService.updateClientCompanyLogo(token, body);
      }
      if (res && res.statusCode === 200) {
        let clientsCompanyInfo = await clientCompanyService.getClientCompany(
          userInformation.clientId,
          token
        );
        console.log(clientsCompanyInfo, "clientsCompanyInfo")
        toggleLoadingRequesting(false);
        moment.locale("es");
        clientsCompanyInfo.data.map((client) => {
          client.clientName = client.company.businessName;
          let dateModification = client.updatedDate.split("T")[0];
          client.lastModificationDate = moment(dateModification)
            .format("DD-MMM-YYYY")
            .replace(/\./g, "");
          client.status = client.company.status;
          client.imgProfile =
            client.company.logo === null
              ? businessIconDefault
              : client.company.logo;
          client.companyName = client.company.companyName;
          client.turnOfTheCompany = client.company.turnOfTheCompany;
          client.typeOfCompany = client.company.typeOfCompany;

          return clientsCompanyInfo.data;
        });
        toggleCompletedRequesting(true, " ", clientsCompanyInfo.data);
        forceRefresh();
        setTimeout(() => {
          hideShowDetails();
        }, 4000);
      } else if (res && res.statusCode === -1) {
        toggleLoadingRequesting(false);
        toggleErrorRequesting(true, " ");
      } else if (res && res.statusCode === 420) {
        toggleLoadingRequesting(false)
        toggleWarningRequesting(true, "Hay un error en la direccion!")
      }
    } catch (error) {
      toggleLoadingRequesting(false);
      toggleErrorRequesting(true, " ");
      setTimeout(() => {
        hideShowDetails();
      }, 4000);
      return false;
    }
  };

  useEffect(() => {
    setStateNameComponentUser(nameComponentUser);
  }, [nameComponentUser]);

  useEffect(() => {
    renderComponentUser();
  }, [stateNameComponentUser]);

  const renderComponentUser = useCallback(() => {

    switch (stateNameComponentUser) {
      case "Domicilio empresa":
        return (
          <BusinessAdministrationAddressView
            selectedUser={selectedUser}
            hideShowDetails={hideShowDetails}
            optionsTypeBusiness={optionsTypeBusiness}
            optionsBusinessTurnover={optionsBusinessTurnover}
            setStateNameComponentUser={setStateNameComponentUser}
            setShowDetails={setShowDetails}
            setHeaderTitleinDetail={setHeaderTitleinDetail}
            token={token}
            showLoadingRequesting={showLoadingRequesting}
            showCompletedRequesting={showCompletedRequesting}
            showErrorRequesting={showErrorRequesting}
            showWarningRequesting={showWarningRequesting}
            toggleLoadingRequesting={toggleLoadingRequesting}
            toggleCompletedRequesting={toggleCompletedRequesting}
            toggleWarningRequesting={toggleWarningRequesting}
            toggleCompletedModel={toggleCompletedModel}
            toggleErrorRequesting={toggleErrorRequesting}
            showDetailComponent={showDetailComponent}
            toggleShowDetailComponent={toggleShowDetailComponent}
            // onChangeImgProfile={onChangeImgProfile}
            updateAddress={updateAddress}
            handleChangeImgProfile={handleChangeImgProfile}
            imgProfileSubtitle={imgProfileSubtitle}
            setImgProfileSubtitle={setImgProfileSubtitle}
            imageProfile={imageProfile}
            changeImgFile={onChangeImgProfile}
            uploadFileCustom={uploadFileCustom}
            nameComponentUser={nameComponentUser}
            message={message}
          />
        );
      case "Inhabilitar empresa":
        return (
          <BusinessAdministrationDisableView
            selectedUser={selectedUser}
            hideShowDetails={hideShowDetails}
            saveStatusForCompany={saveStatusForCompany}
            token={token}
            // onChangeImgProfile={onChangeImgProfile}
            showDetailComponent={showDetailComponent}
            toggleShowDetailComponent={toggleShowDetailComponent}
            showLoadingRequesting={showLoadingRequesting}
            showCompletedRequesting={showCompletedRequesting}
            showErrorRequesting={showErrorRequesting}
            showWarningRequesting={showWarningRequesting}
            toggleLoadingRequesting={toggleLoadingRequesting}
            toggleCompletedRequesting={toggleCompletedRequesting}
            toggleCompletedModel={toggleCompletedModel}
            toggleErrorRequesting={toggleErrorRequesting}
            toggleWarningRequesting={toggleWarningRequesting}
            imgProfileSubtitle={imgProfileSubtitle}
            setImgProfileSubtitle={setImgProfileSubtitle}
            handleChangeImgProfile={handleChangeImgProfile}
            imageProfile={imageProfile}
            changeImgFile={onChangeImgProfile}
            uploadFileCustom={uploadFileCustom}
            setShowDetails={setShowDetails}
            setStateNameComponentUser={setStateNameComponentUser}
            nameComponentUser={nameComponentUser}
            message={message}
          />
        );
      case "Ver detalle/Editar":
        return (
          <BusinessAdministrationDetailView
            selectedUser={selectedUser}
            hideShowDetails={hideShowDetails}
            optionsTypeBusiness={optionsTypeBusiness}
            optionsBusinessTurnover={optionsBusinessTurnover}
            updateCompany={updateCompany}
            createCompany={createCompany}
            token={token}
            validators={validators}
            // onChangeImgProfile={onChangeImgProfile}
            toggleLoadingRequesting={toggleLoadingRequesting}
            showDetailComponent={showDetailComponent}
            toggleShowDetailComponent={toggleShowDetailComponent}
            showLoadingRequesting={showLoadingRequesting}
            showCompletedRequesting={showCompletedRequesting}
            showErrorRequesting={showErrorRequesting}
            showWarningRequesting={showWarningRequesting}
            imgProfileSubtitle={imgProfileSubtitle}
            setImgProfileSubtitle={setImgProfileSubtitle}
            handleChangeImgProfile={handleChangeImgProfile}
            resetImageProfile={resetImageProfile}
            imageProfile={imageProfile}
            changeImgFile={onChangeImgProfile}
            uploadFileCustom={uploadFileCustom}
            toggleCompletedRequesting={toggleCompletedRequesting}
            toggleErrorRequesting={toggleErrorRequesting}
            toggleWarningRequesting={toggleWarningRequesting}
            toggleCompletedModel={toggleCompletedModel}
            setShowDetails={setShowDetails}
            setStateNameComponentUser={setStateNameComponentUser}
            nameComponentUser={nameComponentUser}
            message={message}
          />
        );
      case "Agregar nueva empresa":
        return (
          <BusinessAdministrationDetailView
            selectedUser={selectedUser}
            validators={validators}
            hideShowDetails={hideShowDetails}
            optionsTypeBusiness={optionsTypeBusiness}
            optionsBusinessTurnover={optionsBusinessTurnover}
            createCompany={createCompany}
            updateCompany={updateCompany}
            token={token}
            // onChangeImgProfile={onChangeImgProfile}
            showDetailComponent={showDetailComponent}
            showLoadingRequesting={showLoadingRequesting}
            showCompletedRequesting={showCompletedRequesting}
            showErrorRequesting={showErrorRequesting}
            showWarningRequesting={showWarningRequesting}
            toggleCompletedRequesting={toggleCompletedRequesting}
            toggleErrorRequesting={toggleErrorRequesting}
            toggleLoadingRequesting={toggleLoadingRequesting}
            toggleWarningRequesting={toggleWarningRequesting}
            toggleShowDetailComponent={toggleShowDetailComponent}
            toggleCompletedModel={toggleCompletedModel}
            imgProfileSubtitle={imgProfileSubtitle}
            setImgProfileSubtitle={setImgProfileSubtitle}
            handleChangeImgProfile={handleChangeImgProfile}
            imageProfile={imageProfile}
            changeImgFile={onChangeImgProfile}
            uploadFileCustom={uploadFileCustom}
            setStateNameComponentUser={setStateNameComponentUser}
            setShowDetails={setShowDetails}
            nameComponentUser={nameComponentUser}
            message={message}
            setDataImgProfile={setDataImgProfile}
          />
        );
      default:
        return;
    }
  }, [
    stateNameComponentUser,
    setHeaderTitleinDetail,
    selectedUser,
    hideShowDetails,
    token,
    showGettingData,
    validators,
    showDetailComponent,
    showLoadingRequesting,
    showCompletedRequesting,
    showErrorRequesting,
    showWarningRequesting,
    toggleCompletedRequesting,
    toggleLoadingRequesting,
    toggleWarningRequesting,
    toggleErrorRequesting,
  ]);

  return <>{renderComponentUser()}</>;
};

export default BusinessAdministrationConfigurationsView;

